var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.51213 1L3.89785 6.7982L2.62796 5.46552C2.2791 5.11665 2 4.48869 2 4.07005V2.46525C2 1.62796 2.62796 1 3.39548 1H7.51213Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14.0015 2.39548V3.9305C14.0015 4.48869 13.6526 5.18643 13.3038 5.5353L10.3035 8.1867C9.88484 8.53557 9.60574 9.23331 9.60574 9.7915V12.7918C9.60574 13.2104 9.32665 13.7686 8.97778 13.9779L8.00095 14.6059C7.09389 15.1641 5.83796 14.5361 5.83796 13.4197V9.72172C5.83796 9.23331 5.55886 8.60534 5.27977 8.25647L4.58203 7.52385L8.64287 1H12.606C13.3735 1 14.0015 1.62796 14.0015 2.39548Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5b760a3a28408dac34593ecab2576786.svg";
export { ForwardRef as ReactComponent };